import BusinessInfoModule, {
  BusinessInfoModuleProps,
} from './BusinessInfoModule';

export type {BusinessInfoModuleProps};

export default BusinessInfoModule;
